import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Grid } from '@mui/joy'
import CustomCancelButton from '../../../../Components/custom_components/CustomButtons/CustomCancelButton/CustomCancelButton'
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton'
import crossImg from '../../../../Assets/CommonImages/crossImg.png'
import './RoleFormStyle.css'
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon'
import CustomAutoCompleteDropdown from '../../../../Components/custom_components/CustomAutoCompleteDropdown/CustomAutoCompleteDropdown'
import { role_creation } from '../../../../config/SettingsApis/rolesApis'
import { TbFileDescription } from 'react-icons/tb'
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea'
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown'
import { FaHashtag } from 'react-icons/fa'
import { statusOptions } from '../../../../utils/constants'

function RoleForm({ handleRoleSave, isButtonDisabled, formIntialValues, id }) {

  const formik = useFormik({
    initialValues: formIntialValues,  // Set initial values directly from props

    validationSchema: Yup.object({
      RoleName: Yup.string().required('Role name is required'),
      Rolestatus: Yup.string().required('Status is required'),
      // RoleDescription: Yup.string().required('Status is required')

    }),
    enableReinitialize: true,  // Enable re-initialization of form values when props change
    onSubmit: (values) => {
      handleRoleSave(values, id);

    }

  });

  // Reset handler
  const handleReset = () => {
    formik.setFieldValue("Rolestatus", 1)
    formik.setFieldValue("RoleName", "")
    formik.setFieldValue("RoleDescription", "")
    // Reset warning messages
    formik.setTouched({
      RoleName: false,
      Rolestatus: false,
      RoleDescription: false
    })
  };

  return (
    <div className='role-form-container'>

      {/* TOP SECTION FORM */}
      {/* <div className='role-form-top-container'>
        <div className='role-form-title'>
          <span>Create New Role</span>
        </div>
      </div> */}

      {/* FORM START */}
      <Grid container spacing={2}>

        {/* LEFT SIDE */}
        <Grid item xs={12} md={6}>
          <div className='role-mid-form-container'>
            <div className="label-container">
              <span className="label">Role Name <span className="label_required_remark">*</span></span>
            </div>
            <div className="custom-textfield-container">
              <CustomTextFieldWithIcon
                id="RoleName"
                name="RoleName"
                placeholder="Enter role name"
                value={formik.values.RoleName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.RoleName && Boolean(formik.errors.RoleName)}
                helperText={formik.touched.RoleName && formik.errors.RoleName}
              />
            </div>
          </div>
        </Grid>

        {/* RIGHT SIDE */}
        {id && <Grid item xs={12} md={6}>
          <div className='role-mid-form-container'>
            <div className="label-container">
              <span className="label">Status <span className="label_required_remark">*</span></span>
            </div>
            <div className="custom-textfield-container">
              {/* <CustomAutoCompleteDropdown
                name="Rolestatus"
                placeholder="Select Status"

                options={statusOptions}
                value={statusOptions.find(
                  (option) => option?.value === formik?.values?.Rolestatus
                ) || ""}
                onChange={(selectedOption) => {
                  formik.setFieldValue("Rolestatus", selectedOption ? selectedOption.value : "");
                }}
                onBlur={formik.handleBlur}
                width="100%"
                error={formik.touched.Rolestatus && Boolean(formik.errors.Rolestatus)}
                helperText={formik.touched.Rolestatus && formik.errors.Rolestatus}
              /> */}

              <CustomSelectDropdown
                name="Rolestatus"
                placeholder="Select Status"
                options={statusOptions}
                value={statusOptions?.find(option => option?.value === formik?.values?.Rolestatus) || ""}
                onChange={(selectedOption) => {
                  formik.setFieldValue("Rolestatus", selectedOption ? selectedOption.value : "");
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.Rolestatus && Boolean(formik.errors.Rolestatus)}
                helperText={formik.touched.Rolestatus && formik.errors.Rolestatus}
                StartIcon={<FaHashtag />}
                isClearable={false} // Set to false for single-select
                width="100%"
              />

            </div>
          </div>
        </Grid>}

        <Grid item xs={12} md={6}>
          {/* RoleDescription */}
          <div className="label-container">
            <span className="label">Description<span className='label_required_remark'></span></span>
          </div>
          <div className="custom-textfield-container">
            <CustomTextArea
              id="RoleDescription"
              name="RoleDescription"
              placeholder="Enter RoleDescription"
              value={formik.values.RoleDescription}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows={5}
              StartIcon={TbFileDescription}

            />
          </div>
        </Grid>

      </Grid>

      <div className='form-bottom-action-buttons-container'>
        {/* <CustomCancelButton label={`Cancel`} /> */}
        <ActionButton onClick={handleReset}
          label={`Reset`}
          btnType={`outlined`}
        />
        <ActionButton onClick={() => formik.handleSubmit()}
          btnDisable={isButtonDisabled}
          label={`Save`}
          btnType={`primary`}
        />
      </div>

    </div>
  )
}

export default RoleForm;